<template>
    <div class="doubleBarChart"></div>
</template>

<script>
export default {
    name: '',
    props:["pondsid"],

    data() {
        return {
            myChart: null,
            xData:[],
            yData:[]
        } 
    },
    methods: {
        setData(){
            
            this.request.get("/api/Echart/getArtpage2",{
                params: {
                    pondsid:this.pondsid,
                    param: "nitr",
                    number:10
                }
            }).then(res => {
                if(res.code == 200){
                    let data = res.data;
                    this.xData = data.map(item =>{ // 假设 item.time 是 "2024-03-30T10:03:47"  
                    const dateParts = item.date.split('-'); 
                    const month = dateParts[1];
                    const day = dateParts[2].split('T')[0]; 
                    return `${month}-${day}`;});
                    this.yData = data.map(item => item.nitr)    
                }
                
                this.setChart()
            })
        },
        setChart() {
            const allNull = this.yData.every(item => item === null);
            let option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                    backgroundColor: '#11367a',
                    textStyle: {
                        color: '#6dd0e3',
                        fontSize: 10,
                    },
                },
                graphic: allNull ? [{
            type: 'text',
            left: 'center', // 根据需要调整位置
            top: 'center',
            style: {
                // text: '暂无此数据',
                // textAlign: 'center',
                // fill: '#ccc', // 文本颜色
                // fontSize: 25
            }
        }] : [],
                legend: [
                    {
                        top: '8%',
                        right: '5%',
                        itemWidth: 7,
                        itemHeight: 7,
                        textStyle: {
                            color: '#fff',
                        }
                    },
                ],
                grid:
                    {
                        top: '15%',
                        left: '3%',
                        right: '5%',
                        bottom: '8%',
                        containLabel: true,
                    },
                xAxis: [
                    {
                        type: 'category',
                        axisLabel: {
                            interval: 0,
                            color: '#fff',
                            fontSize: 10
                        },
                        axisLine: {
                            symbol: ['none', 'arrow'],
                            symbolSize: [6, 6],
                            symbolOffset: [0, 5],
                            lineStyle: {
                                color: '#122C49'
                            }
                        },
                        axisTick: {show: false},
                        // data: ['15:00', '15:05', '15:10', '15:20', '15:25', '15:30', '15:35', '15:40', '15:45', '15:50']
                        data: this.xData
                    },
                ],
                yAxis:
                    {
                        type: 'value',
                        min: 0,
                        max: 0.5,
                        interval: 0.05,
                        axisLabel: {
                            color: '#fff',
                            fontSize: 9,
                            showMaxLabel: false,
                        },
                        axisLine: {
                            symbol: ['none', 'arrow'],
                            symbolSize: [6, 6],
                            symbolOffset: [0, 5],
                            lineStyle: {
                                color: '#122C49'
                            }
                        },
                        axisTick: {
                            length: 3
                        },
                        name: '(mg/L)',
                        nameGap: -5,
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: 9,
                            align: 'right',
                            padding: [0, 6, 0, 0]
                        },
                        splitLine: {show: false}

                    },
                series: [
                    {
                        name: '亚硝酸盐浓度',
                        type: 'bar',
                        barWidth: 7,
                        stack: '亚硝酸盐浓度',
                        itemStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#FC9386' // 0% 处的颜色
                                },
                                    {
                                        offset: 0.4, color: '#F87B86' // 40% 处的颜色
                                    }, {
                                        offset: 1, color: '#F36087' // 100% 处的颜色
                                    }],
                                global: false // 缺省为 false
                            }, //背景渐变色
                            borderRadius: [3.5, 3.5, 0, 0],
                        },
                        // data: [0.05, 0.15, 0.25,0.35,0.45,0.4,0.5,0.3,0.08,0.18,0.49]
                        data: this.yData
                    },
                    // {
                    //     name: '总数',
                    //     type: 'bar',
                    //     barWidth: 7,
                    //     stack: '总数',
                    //     itemStyle: {
                    //         color: '#8C14EA',
                    //         borderRadius: [3.5, 3.5, 0, 0,],
                    //     },
                    //     data: [120, 132, 101, 134, 90, 130, 110, 90, 130, 120]
                    // },

                ]
            };
            if (!this.myChart) this.myChart = this.$echarts(this.$el);
            this.myChart.clear();
            this.myChart.resize()
            this.myChart.setOption(option);
        }
    },
    mounted() {
        this.setData()
    },
    watch: {
        pondsid() {
            this.setData()
        }
    }
}
</script>

<style lang="less" scoped>
.doubleBarChart {
    width: 100%;
    height: 100%;
}
</style>
